import Vue from 'vue'
import VueI18n from 'vue-i18n'

import enUS from './en-US'
import enAU from './en-AU'
import enGB from './en-GB'
import frCA from './fr-CA'

Vue.use(VueI18n)

const messages = {
  'en-US': enUS,
  'fr-CA': frCA,
  'en-AU': enAU,
  'en-GB': enGB
}

export default {
  app: new VueI18n({
    locale: 'en-US',
    fallbackLocale: 'en-US',
    messages
  }),
  getLocale: function (lang) {
    if (!lang) return 'en-US'
    if (typeof lang !== 'string') return 'en-US'
    return lang
  }
}
